import React from 'react';
import PropTypes from 'prop-types';
import DrupalHelper from '../../helper/DrupalHelper';

class Marker extends React.Component {
  constructor(props) {
    super(props);
    this.state = { show_infobox: false };
  }

  render() {
    const { icon, entries } = this.props;
    const marker_icon = {
      backgroundImage: 'url(' + icon + ')',
    };

    return <div className='map-marker'
      hidden={this.props.hidden}
      style={marker_icon}
      title={''}
      onMouseEnter={() => this.setState({ show_infobox: true })}
      onMouseLeave={() => this.setState({ show_infobox: false })}>
      {entries.length && <div className="marker-infobox"
        hidden={!this.state.show_infobox}>
        <div>
          {this.props.legend && <h4>{DrupalHelper.getLegendLabel(this.props.legend)}</h4>}
          {this.props.country && <h5><em>{this.props.country}</em></h5>}

          <ul>
            {entries.sort().map((entry, index) => {
              let link = 'https://www.ncbi.nlm.nih.gov/pubmed?term=' + entry.title + '[Author]';

              if (entry.custom_link) {
                link = entry.custom_link;
              } else if (entry.disable_pubmed_link) {
                return <li key={index}><span>{entry.title}</span></li>
              }

              return <li key={index}>
                <a target="_blank"
                  rel="noopener noreferrer"
                  href={link}>
                  {entry.title}
                </a>
              </li>
            })}
          </ul>
        </div>
      </div>}
    </div>
  }
}

Marker.defaultProps = {
  hidden: false,
  icon: '',
  legend: '',
  country: '',
  entries: []
};

Marker.propTypes = {
  hidden: PropTypes.bool,
  icon: PropTypes.string,
  legend: PropTypes.string,
  country: PropTypes.string,
  entries: PropTypes.array
};

export default Marker;
